import { ProductLabel, Link, theme } from '@notino/react-styleguide';

import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const ReviewMotivationProductLabel = styled(ProductLabel)`
  font-size: 0.75rem;
  text-transform: none;
  padding: 0.25rem 0.375rem;
`;

/** Unstyled button so the label text stays keyboard-focusable. */
export const ReviewMotivationTrigger = styled.button`
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  cursor: pointer;
`;

export const verifiedReviewLabelClass = css`
  color: ${theme.color.text.positive};
`;

export const TooltipContent = styled.div`
  max-width: max-content;
  width: 15rem;
  padding: 0.5rem;
`;

export const MoreInfoLink = styled(Link)`
  margin-left: 0.25rem;
  text-decoration: underline;
`;
